import { useState } from "react";
import { faqList } from "@/mocks/homeData";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqList[0].id);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
        <div className="lg:col-span-2">
          <span className="text-xs font-medium tracking-wide text-accent-600">常见问答</span>
          <h2 className="mt-2 font-heading font-bold text-xl md:text-3xl text-foreground-950">
            关于入口与地址的高频问题
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            这里汇总了访问 91网 时最常遇到的疑问，看完基本就能判断入口是否有效、打不开该怎么处理。
          </p>

          <div className="mt-6 rounded-lg border border-accent-300 bg-accent-50 p-5">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-lightbulb-line"></i>
              </span>
              <h4 className="font-medium text-sm text-accent-900">快速提示</h4>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-accent-900/80">
              遇到打不开先别急着重装浏览器，多数情况换个网络、清个缓存或换条线路就能恢复。把本页收藏好，地址变动也不会迷路。
            </p>
          </div>
        </div>

        <div className="lg:col-span-3 flex flex-col gap-3">
          {faqList.map((faq) => {
            const open = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={`bg-background-50 rounded-lg border transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? "" : faq.id)}
                  className="w-full flex items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer"
                >
                  <span className="flex items-center gap-3 min-w-0">
                    <i className="ri-question-line text-primary-500 shrink-0"></i>
                    <span className="font-medium text-sm text-foreground-950">{faq.q}</span>
                  </span>
                  <i
                    className={`shrink-0 text-foreground-500 transition-transform ${
                      open ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {open && (
                  <div className="px-4 pb-4 pl-10">
                    <p className="text-xs leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}